<div class="h-full bg-white">
    <div class="flex items-center justify-center py-8">
        <div class="absolute left-4 h-5 w-5" (click)="handleBackArrow()">
            <ion-icon
                class="h-5 w-5 dark:filter-yellow"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
        </div>

        <h1 class="vl-app-light:font-bold mx-1 text-base font-semibold">
            {{ 'SET_NEW_PASSWORD' | translate }}
        </h1>
    </div>

    <div class="mb-4 px-4">
        <div>
            {{ 'RECOVER_PASSWORD_DESCRIPTION' | translate }}
        </div>
    </div>

    <form class="px-4" [formGroup]="passwordForm" (ngSubmit)="submitPassword()" ridangoFocusInvalidInput>
        <mat-form-field class="full-width text-primary" appearance="outline">
            <mat-label
                [attr.aria-label]="'PH_RECOVER_PASSWORD' | translate"
                title="{{ 'PH_RECOVER_PASSWORD' | translate }}">
                {{ 'PH_RECOVER_PASSWORD' | translate }}
            </mat-label>
            <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                [attr.aria-label]="'PH_RECOVER_PASSWORD' | translate"
                formControlName="password"
                title="{{ 'PH_RECOVER_PASSWORD' | translate }}"
                matInput
                ridangoInput
                required
                ridangoUntouchOnFocusout />
            <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
                <button
                    class="gl-light:text-[var(--color-secondary)] text-primary"
                    [attr.aria-label]="'HIDE_PASSWORD_ARIA_LABEL' | translate"
                    [attr.aria-pressed]="showPassword"
                    (click)="showPassword = !showPassword"
                    matSuffix
                    type="button">
                    <mat-icon class="orb-app-light:text-secondary">{{
                        showPassword ? 'visibility' : 'visibility_off'
                    }}</mat-icon>
                </button>
            </div>

            <mat-hint id="recover-password-hint">
                <ridango-ui-mat-list-hint
                    titleTerm="PASSWORD_REQUIREMENT_HINT_TITLE"
                    listTerm="PASSWORD_REQUIREMENT_HINT_LIST">
                </ridango-ui-mat-list-hint>
            </mat-hint>

            <mat-error
                *ngIf="passwordForm.controls.password.touched && passwordForm.controls.password.hasError('required')">
                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
            </mat-error>
            <mat-error
                *ngIf="passwordForm.controls.password.touched && passwordForm.controls.password.hasError('minlength')">
                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width text-black dark:text-contrast-yellow" appearance="outline">
            <mat-label
                [attr.aria-label]="'PH_NEW_PASSWORD_AGAIN' | translate"
                title="{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}"
                >{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}</mat-label
            >
            <input
                id="passwordRepeat"
                [type]="showPasswordRepeat ? 'text' : 'password'"
                [attr.aria-label]="'PH_NEW_PASSWORD_AGAIN' | translate"
                formControlName="passwordRepeat"
                title="{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}"
                matInput
                ridangoInput
                required
                ridangoUntouchOnFocusout />
            <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
                <button
                    class="gl-light:text-[var(--color-secondary)] text-primary"
                    [attr.aria-label]="'HIDE_PASSWORD_ARIA_LABEL' | translate"
                    [attr.aria-pressed]="showPasswordRepeat"
                    (click)="showPasswordRepeat = !showPasswordRepeat"
                    matSuffix
                    type="button">
                    <mat-icon class="orb-app-light:text-secondary">{{
                        showPasswordRepeat ? 'visibility' : 'visibility_off'
                    }}</mat-icon>
                </button>
            </div>
            <mat-error
                *ngIf="passwordForm.controls.passwordRepeat.touched"
                [ngSwitch]="
                    getFirstError(passwordForm.controls.passwordRepeat, ['required', 'minlength', 'numberRequired'])
                ">
                <ng-container *ngSwitchCase="'required'">
                    {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'minlength'">
                    {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'numberRequired'">
                    {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                </ng-container>
            </mat-error>
        </mat-form-field>

        <div class="btn-position fixed w-full">
            <div class="pr-8">
                <button
                    class="vl-app-light:bg-[var(--btn-primary-color)] var-app-light:text-black orb-app-light:bg-primary orb-app-light:text-black flex-align-center vl-app-light:text-black flex h-14 w-full justify-center rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    type="submit">
                    <ion-label class="flex-align-center flex text-base font-bold normal-case">
                        {{ 'CONFIRM_NEW_PASSWORD' | translate }}
                    </ion-label>
                </button>
            </div>
        </div>
    </form>
</div>
